import { createSelector } from 'reselect';
import { reformatForOptionsMenu } from 'src/store/actions/employeesActions';

const emptyObj = {};

const getEmployees = (state) => state.employees || {};

export const selectFetching = createSelector(
  getEmployees,
  ({ fetching }) => fetching
);

export const selectAllEmployees = createSelector(
  getEmployees,
  ({ allEmployees }) => allEmployees
);

export const selectEmployeeByUserId = createSelector(
  getEmployees,
  ({ allEmployees }) => (userId) => allEmployees?.find((employee) => employee.UserId === +userId)
);

export const selectEmployeeFullNameByUserId = createSelector(
  getEmployees,
  ({ allEmployees }) => (userId) => {
    const employee = allEmployees?.find((_employee) => _employee.UserId === +userId);
    return employee ? `${employee.FirstName.trim()} ${employee.LastName.trim()}` : '';
  }
);

export const selectEmployeesList = createSelector(
  getEmployees,
  ({ list }) => list
);

export const selectFromEmployeesListByUserId = createSelector(
  getEmployees,
  ({ list }) => (userId) => list.find((employee) => employee.UserId === userId)
);

export const selectFullInfoEmployeesList = createSelector(
  getEmployees,
  ({ fullInfoList }) => fullInfoList
);

export const selectEmployeesOptions = createSelector(
  getEmployees,
  ({ options }) => options
);

export const selectAllEmployeesOptions = createSelector(
  getEmployees,
  ({ list }) => reformatForOptionsMenu(list, true)
);

export const selectEmployeesUserInfo = createSelector(
  getEmployees,
  ({ userInfo }) => userInfo
);

export const selectUserTimeRateSystem = createSelector(
  selectEmployeesUserInfo,
  ({ timeRateSystem }) => timeRateSystem || emptyObj
);

export const selectTimeRateFetching = createSelector(
  getEmployees,
  ({ timeRateFetching }) => timeRateFetching
);

export const selectEmployeesUserInfoFetching = createSelector(
  getEmployees,
  ({ userInfoFetching }) => userInfoFetching
);

export const selectEmployeesContractType = createSelector(
  getEmployees,
  ({ contractType }) => contractType
);

export const selectEmployeesContractOptions = createSelector(
  getEmployees,
  ({ contractOptions }) => contractOptions
);

export const selectEmployeeContractsFetching = createSelector(
  getEmployees,
  ({ contractTypeFetching }) => contractTypeFetching
);

export const selectEmployeesCardTypes = createSelector(
  getEmployees,
  ({ cardTypes }) => cardTypes
);

export const empty = () => {};
